import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLock,
  faLockOpen,
  faMinus,
  faPlus,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import NumberFormat from 'react-number-format';
import { setFontSize } from '../helpers/helpers';
import Icon from './UI/Icon';
import '../styles/cards.css';
import isUserHasProfile from '../helpers/profileValidator';
import { GARANTIA_EDIT_WRITE, GARANTIA_EXPOSICION_MAXIMA_WRITE } from '../helpers/profilePermission';

const isUserHasProfileByNode = (node) => {
  if (node.nemotecnico === 'exposicion_maxima'){
    return isUserHasProfile(GARANTIA_EXPOSICION_MAXIMA_WRITE);
  }
  return isUserHasProfile(GARANTIA_EDIT_WRITE);
}

const DetailCard = ({ detail, handleEdit, handleView, node }) => {
  const isDisabled = detail[`mov_${node.nemotecnico}_borrador`];
  return (
    <div>
      <div className="card-wrapper">
        <div className="text-center card-text">
          <div className="title font-weight-bold pt-2" style={{fontSize: "16px"}}>{node.label}</div>
          <div
            className="value"
            style={{ fontSize: setFontSize(detail.balance[node.nemotecnico]) }}
          >
            <NumberFormat
              decimalScale="2"
              fixedDecimalScale
              decimalSeparator=","
              displayType="text"
              value={detail.balance[node.nemotecnico]}
              thousandSeparator="."
            />
            &nbsp; UF
            <Icon
              className="detail"
              handleOnClick={e => handleView(e, node)}
              id={`show-${node.nemotecnico}`}
              placement="right"
              tooltipText={<span className="show-tooltip">Ver Tabla</span>}
            >
              <FontAwesomeIcon className="table-link" icon={faSearch} />
            </Icon>
          </div>
        </div>
        {node.nemotecnico === 'cumulo' || node.nemotecnico === 'cumulo_proyectos' ? (
          <div className="card-buttons">
            {isUserHasProfile(GARANTIA_EDIT_WRITE) && (
              <Button onClick={e => handleEdit(e, node)} className="Bloquear">
                &nbsp;
                <FontAwesomeIcon
                  className="table-link"
                  icon={detail.balance.bloqueada ? faLockOpen : faLock}
                />
                &nbsp;&nbsp;
                {detail.balance.bloqueada ? 'Desbloquear' : 'Bloquear'}
              </Button>
            )}
          </div>
        ) : (
          <div className="card-buttons">
            {isUserHasProfileByNode(node) && (
              <>
                <Button
                  className="aumentar"
                  disabled={isDisabled}
                  onClick={e => handleEdit(e, node, true)}
                >
                  &nbsp;
                  <FontAwesomeIcon className="table-link" icon={faPlus} />
                  &nbsp; Aumentar
                </Button>
                <Button
                  className="disminuir"
                  disabled={isDisabled}
                  onClick={e => handleEdit(e, node, false)}
                >
                  &nbsp;
                  <FontAwesomeIcon className="table-link" icon={faMinus} />
                  &nbsp; Disminuir
                </Button>
              </>
            )}
          </div>
        )}
      </div>
      {isDisabled && isUserHasProfileByNode(node) && (
        <p className="disable-warning">
          <span style={{ color: 'var(--orsan-blue)' }}>*</span>
          &nbsp; No se puede aumentar ni disminuir el monto
        </p>
      )}
    </div>
  );
};

DetailCard.propTypes = {
  detail: PropTypes.shape({
    balance: PropTypes.shape({
      bloqueada: PropTypes.bool,
    }),
  }).isRequired,
  handleEdit: PropTypes.func,
  handleView: PropTypes.func.isRequired,
  node: PropTypes.shape({
    tipo_id: PropTypes.number,
    label: PropTypes.string,
    nemotecnico: PropTypes.string,
  }).isRequired,
};

DetailCard.defaultProps = {
  handleEdit: () => {},
};

export default DetailCard;
